import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<Home::MwHomeLoginPage @model={{this.model}} />",{ moduleName: "mewe/templates/web3-login.hbs" })